var map = {
	"./Docker.png": 76810,
	"./FastAPI.png": 80430,
	"./Jupyter.png": 37419,
	"./MySQL.png": 8015,
	"./NumPy.png": 83442,
	"./Pandas.png": 72598,
	"./PyTorch.png": 26898,
	"./Python.png": 58052,
	"./Qiskit.png": 75433,
	"./Scrapy.png": 33567,
	"./Smartprix.png": 98332,
	"./Spring.png": 91954,
	"./Ubuntu.png": 2561,
	"./Vue.png": 95236,
	"./csv.png": 12299,
	"./dns.png": 78448,
	"./file.png": 37408,
	"./github.png": 86127,
	"./ipynb.png": 69283,
	"./pdf.png": 39113,
	"./scikit-learn.png": 16378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16003;